import { type WorkspaceSuperApp, getWorkspaceSuperAppService } from './WorkspaceSuperApp.class';

function checkSuperAppService(service?: WorkspaceSuperApp): asserts service is WorkspaceSuperApp {
    if (!service) {
        throw new Error('WorkspaceSuperAppService is not defined, possibly running in SSR');
    }
}

/* @deprecated legacy import, use getWorkspaceSuperAppService instead */
export const WorkspaceSuperAppService = (() => {
    const serviceInstance = getWorkspaceSuperAppService();

    checkSuperAppService(serviceInstance);

    return serviceInstance;
})();
